"use client";

import React, { type FC } from "react";
import { ImgPartyChatEmpty } from "~/src/assets/img";
import { Body1 } from "~/src/components/Common/Text";
import EmptyState from "~/src/components/Common/EmptyState";
import { useTranslations } from "next-intl";

const EmptyConversation: FC = () => {
  const t = useTranslations();
  return (
    <EmptyState
      className="w-full h-full flex flex-col justify-center items-center flex-1"
      illustration={
        <img
          src={ImgPartyChatEmpty}
          alt="No Conversation"
          className="w-48 h-auto object-contain"
        />
      }
    >
      <Body1 className="text-center mt-6 mb-4">
        {t("web.select_conversation")}
      </Body1>
    </EmptyState>
  );
};

export default EmptyConversation;
